'use client';

import React from 'react';

interface PauseMenuProps {
  onResume: () => void;
  onRestart: () => void;
  onQuit: () => void;
  currentScore: number;
  bestScore: number;
}

export default function PauseMenu({
  onResume,
  onRestart,
  onQuit,
  currentScore,
  bestScore,
}: PauseMenuProps) {
  return (
    <div className="absolute inset-0 z-40 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0"
        style={{ background: 'rgba(13,13,15,0.75)', backdropFilter: 'blur(8px)' }}
        onClick={onResume}
      />

      {/* Panel */}
      <div
        className="relative flex flex-col items-center gap-5 stripe-modal-enter"
        style={{
          background: 'rgba(13,13,15,0.95)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(0,229,255,0.2)',
          borderRadius: '28px',
          padding: '36px 32px',
          maxWidth: '300px',
          width: '88%',
        }}
      >
        {/* Title */}
        <div className="flex flex-col items-center gap-1">
          <p
            className="text-2xl font-bold tracking-wide"
            style={{ color: '#00e5ff', fontFamily: 'DM Sans, sans-serif', textShadow: '0 0 16px rgba(0,229,255,0.6)' }}
          >
            PAUSED
          </p>
          <p className="text-xs tracking-widest uppercase" style={{ color: '#556677', fontFamily: 'DM Sans, sans-serif' }}>
            Surfsterre · Italy
          </p>
        </div>

        {/* Score summary */}
        <div
          className="w-full rounded-2xl px-4 py-3 flex items-center justify-between"
          style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}
        >
          <div className="flex flex-col">
            <p className="text-[10px] tracking-widest uppercase" style={{ color: '#556677', fontFamily: 'DM Sans, sans-serif' }}>Current</p>
            <p className="font-mono-game text-xl font-bold" style={{ color: '#ffd60a' }}>
              {currentScore.toLocaleString()}
            </p>
          </div>
          <div className="w-px h-8" style={{ background: 'rgba(255,255,255,0.08)' }} />
          <div className="flex flex-col items-end">
            <p className="text-[10px] tracking-widest uppercase" style={{ color: '#556677', fontFamily: 'DM Sans, sans-serif' }}>Best</p>
            <p className="font-mono-game text-xl font-bold" style={{ color: '#00e5ff' }}>
              {bestScore.toLocaleString()}
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3 w-full">
          <button
            className="w-full py-4 rounded-2xl font-bold text-base tracking-wide btn-action"
            style={{
              background: 'linear-gradient(135deg, #00e5ff 0%, #0077ff 100%)',
              color: '#0d0d0f',
              fontFamily: 'DM Sans, sans-serif',
            }}
            onClick={onResume}
            onTouchStart={e => { e.preventDefault(); onResume(); }}
          >
            Resume Run
          </button>

          <button
            className="w-full py-3.5 rounded-2xl font-bold text-sm tracking-wide btn-action"
            style={{
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.12)',
              color: '#8899aa',
              fontFamily: 'DM Sans, sans-serif',
            }}
            onClick={onRestart}
            onTouchStart={e => { e.preventDefault(); onRestart(); }}
          >
            Restart Track
          </button>

          <button
            className="w-full py-3 rounded-2xl font-medium text-sm tracking-wide btn-action"
            style={{
              color: '#556677',
              fontFamily: 'DM Sans, sans-serif',
            }}
            onClick={onQuit}
            onTouchStart={e => { e.preventDefault(); onQuit(); }}
          >
            Exit to Menu
          </button>
        </div>

        {/* Tip */}
        <p
          className="text-center text-[10px] leading-relaxed"
          style={{ color: '#334455', fontFamily: 'DM Sans, sans-serif' }}
        >
          Tip: Land a trick right after a jump to start a combo chain
        </p>
      </div>
    </div>
  );
}